import { DispatchType } from '../../../@types/redux-types'
import {
  geoAutocompletionSchedule,
  getGeoAutocompletionRequest,
} from '../../actions/geoAutocompletion/geoAutocompletion'
import { GeoAutocompletionType } from '../../../@types/types'
import { loadGeoAutocompletion } from '../../../api/geoAutocompletion/geoAutocompletionApi'
import { showMessage } from '../../reducers/message/messageFeature'
import { getGeoAutocompletionSuccess } from '../../reducers/address/addressFeature'

const WAIT_INTERVAL = 500
let timer: ReturnType<typeof setTimeout>

export const getGeoAutocompletionLocations =
  (input: string, type: GeoAutocompletionType, secondInput?: string) => async (dispatch: DispatchType) => {
    if (input.length >= 1) {
      dispatch(getGeoAutocompletionRequest(input, type, secondInput))
      try {
        const locations = await loadGeoAutocompletion(input, type, secondInput)
        locations
          ? dispatch(getGeoAutocompletionSuccess({ locations: locations, type: type }))
          : dispatch(getGeoAutocompletionSuccess({ locations: [] }))
      } catch (error) {
        dispatch(showMessage({ message: 'unknown' }))
        dispatch(getGeoAutocompletionSuccess({ locations: [] }))
      }
    } else {
      dispatch(getGeoAutocompletionSuccess({ locations: [] }))
    }
  }

export const onChangeGeoAutocompletionInput =
  (input: string, type: GeoAutocompletionType, secondInput?: string) => (dispatch: DispatchType) => {
    clearTimeout(timer)
    dispatch(geoAutocompletionSchedule())
    timer = setTimeout(() => getGeoAutocompletionLocations(input, type, secondInput)(dispatch), WAIT_INTERVAL)
  }
